module.exports = __webpack_public_path__ + "static/media/calendar_carrer.62236ff7.svg";